import React, { useEffect, useState } from "react";
import { withRouter, Link, useHistory, useLocation } from 'react-router-dom';
import RateCard from '../../../../../Util/RateCard/RateCard';
import Tab from '../../../../../Util/Tabs/Tab';
import "../Leagues.css";
import DataTableComponent from "../../../../../Util/DataTable/DataTable";
import Popup from "reactjs-popup";
import SeasonPopup from "../SeasonPopup/Season";
import { BACK_DROP_FALSE, LEAGUE_STATUS, loadColumns } from "../../../../../Util/helper";
import add from "../../../../../assets/add-icon.svg";
import "./Overview.css";
import axiosApi from "../../../../../core/interceptor/interceptor";
import { config, PERMISSIONS } from "../../../../../config";
import { useDispatch, useSelector } from "react-redux";
import { setCopyLeague } from "../../../../../Store/reducers/CopyLeagueReducer";
import { Fragment } from "react";
import { permissions } from "../../../../../Store/reducers/PermissionsReducer";
import _ from "lodash";
import CustomSelect from "../../../../../Util/CustomSelect/CustomSelect";
import { setFilters, overviewFiltersList } from "../../../../../Store/reducers/OverviewFilters";
import WarningDialogue from "../../../../../Util/WarningDialogue";

const conditionalRowStyles = [
  {
    when: row => !!row.toggleSelected,
    style: {
      backgroundColor: "#82eead",
    }
  }
];

function Overview(props) {
  const oldFilers = useSelector(overviewFiltersList);
  const permission = useSelector(permissions);
  const [leagues, setLeagues] = useState([]);
  const [move, setMove] = useState(false);
  const [copy, setCopy] = useState(false);
  const [selectedLeague, setSelectedLeague] = useState([]);
  const [selectedTab, setSelectedTab] = useState('');
  const [total, setTotal] = useState(0);
  const searchLocation = useLocation().search;
  const [season_id, setSeasonID] = useState(new URLSearchParams(searchLocation).get('season_id'));
  const [statistics, setStatistics] = useState([
    {
      text: 'Revenue',
      value: '$0',
      type: 'revenue',
    },
    {
      text: 'Outstanding Revenue',
      value: '$0',
      type: 'revenue',
    },
    {
      text: 'Total Teams',
      value: '0'
    },
  ]);

  const [filter, setFilter] = useState({
    limit: oldFilers?.limit || 50,
    page: oldFilers?.page || 1,
    sort_column: oldFilers?.sort_column || 'created_at',
    direction: oldFilers?.direction || 'desc',
    place: oldFilers?.place || '',
    season_id: oldFilers?.season_id || 0,
    season_name: oldFilers?.season_name || '',
    status: oldFilers?.status || '',
    indvRegAllow: (oldFilers?.indvRegAllow === true || oldFilers?.indvRegAllow === false) ? oldFilers?.indvRegAllow : '',
    searchString: oldFilers?.searchString || '',
    sport: oldFilers?.sport || 0,
  });
  const [addEditPermission, setAddEditPermission] = useState({
    league: false,
    revenue: false,
  });
  const [columns, setColumns] = useState([]);
  const dispatch = useDispatch();
  const [loader, setLoader] = useState(true);
  const [sportsList, setSportsList] = useState([]);
  const [openWarningPopup, setOpenWarningPopup] = useState(false);
  const [popupContent, setPopupContent] = useState({});
  const [leagueId, setLeagueId] = useState(0);
  const history = useHistory();

  const columns_ = [
    {
      name: 'Status',
      selector: 'status',
      type: 'status',
      dropdown: true,
      showWarning: true,
      options: [
        {
          id: "active",
          title: "Active"
        },
        {
          id: "complete",
          title: "Complete"
        },
        {
          id: "cancel",
          title: "Cancel"
        },
        {
          id: "sign_up",
          title: "Sign-up"
        },
        {
          id: 'need_schedule',
          title: 'Needs Schedule',
        },
        {
          id: "archive",
          title: "Archive"
        }
      ],
      style: {
        display: 'inline-block'
      }
    },
    {
      name: 'Name',
      selector: 'name',
      type: 'hosted_by',
    },
    {
      name: 'Weeks',
      selector: 'no_of_weeks',
    },
    {
      name: 'Sport',
      selector: 'sport.title',
    },
    {
      name: 'Teams',
      selector: 'teamsCount',
    },
    {
      name: 'IR',
      selector: 'days_played',
    },
    {
      name: 'Waiting',
      selector: 'waiting',
      sortable: false,
    },
    {
      name: 'Revenue',
      selector: 'revenu',
      sortable: false,
      cell: row => (<div>{row.revenu ? `$${row.revenu}` : 'N/A'}</div>)
    },
    {
      name: 'FF Pending',
      selector: 'refund_applicable',
      sortable: false,
      type: 'refund_applicable',
      cell: row => (<div>{row.refund_applicable ? `$${row.refund_applicable}` : '0'}</div>)
    },
    {
      name: 'FF Received',
      selector: 'refunded',
      sortable: false,
      type: 'refunded',
      cell: row => (<div>{row.refunded ? `$${row.refunded}` : '0'}</div>)
    },
    // {
    //   name: 'Comped',
    //   selector: 'comped',
    //   sortable: false,
    // },
    // {
    //   name: 'Outstanding',
    //   selector: 'outstanding',
    //   sortable: false,
    // },
    {
      name: 'Action',
      selector: 'table_action',
      sortable: false,
      mode: 'action',
      type: 'table_action',
      actionHandler: function (e) {
        setLeagueId(e?.id);
        setOpenWarningPopup(true);
      } ,
      style: { width: '50%' }
    },
  ];

  useEffect(() => {
    if (season_id) {
      getSeasonInfo(season_id);
    } else if (props.location &&
      props.location.state &&
      props.location.state.season_id &&
      props.location.state.season_name) {
      setFilter(prev => {
        const filter_ = {
          ...prev,
          season_id: props.location.state.season_id,
          season_name: props.location.state.season_name,
        };
        return filter_;
      });
    } else if (props.location &&
      props.location.state &&
      props.location.state.season_id) {
      getSeasonInfo(props.location.state.season_id);
    } else {
      const place = props.location.pathname.split('/').pop();
      if (['/mulberry', '/cleveland'].includes(`/${place}`)) {
        setFilter(prev => ({
          ...prev,
          place,
        }));
      }
    }
    getSports();
    //eslint-disable-next-line
  }, []);

  useEffect(() => {
    setPermission();
    //eslint-disable-next-line
  }, [permission.length]);

  useEffect(() => {
    dispatch(setCopyLeague(move));
    //eslint-disable-next-line
  }, [move, copy]);


  useEffect(() => {
    const ids = [];
    if (leagues && leagues.length) {
      leagues.forEach((league) => {
        if (league.toggleSelected) {
          ids.push(league.id);
        }
      });
    }
    setSelectedLeague(ids);
  }, [leagues]);

  useEffect(() => {
    getLeagueStatistics();
    //eslint-disable-next-line
  }, [selectedTab, filter.season_id]);

  useEffect(() => {
    const filter_ = _.cloneDeep(filter);
    if (props.location &&
      props.location.state &&
      props.location.state.season_id &&
      props.location.state.season_name) {
      filter_.season_id = props.location.state.season_id;
      filter_.season_name = props.location.state.season_name;
    }
    getLeagues(filter_);
    dispatch(setFilters(filter_));
    //eslint-disable-next-line
  }, [
    filter.status,
    filter.indvRegAllow,
    filter.sport.id,
    filter.place,
    filter.season_id
  ]);


  useEffect(() => {
    dispatch(setFilters(filter));
  }, [filter.searchString, filter?.sport?.id, filter.indvRegAllow]);

  const getSeasonInfo = (id) => {
    axiosApi.get(`${config.apiUrl}/seasons/${id}`).then((res) => {
      setFilter(prev => {
        const filter_ = {
          ...prev,
          season_id: id,
          season_name: res.data.data.name,
        };
        return filter_;
      });
    }).catch((err) => {
      console.error(err);
    })
  }

  const tabList = [
    {
      name: "All Leagues",
      url: "",
      search: `${(season_id) ? `season_id=${season_id}` : ''}`
    },
    {
      name: "Mulberry's",
      url: "/mulberry",
      search: `${(season_id) ? `season_id=${season_id}` : ''}`
    },
    {
      name: "Cleveland Plays",
      url: "/cleveland",
      search: `${(season_id) ? `season_id=${season_id}` : ''}`
    }
  ];

  const [tabs, setTabList] = useState(tabList);

  useEffect(() => {
    setTabList(prev => {
      const newTab = tabs;
      newTab.map(value =>
        value['search'] = `${(season_id) ? `season_id=${season_id}` : ''}`);
      return newTab;
    });
  }, [season_id])

  const [open, setOpen] = useState(false);

  const closeModal = (data) => {
    if (data) {
      if (move) {
        moveLeague(data);
      } if (copy) {
        copyLeague(data);
      } else {
        setFilter((prev) => {
          const location = history.location;
          setSeasonID(data.id);
          history.replace({
            ...history,
            location: { ...location, state: { season_id: data.id, season_name: data.name } },
            search: `?season_id=${data.id}`,
          });
          const filter_ = { ...prev, season_id: data.id, season_name: data.name };
          getLeagues(filter_);
          return filter_;
        });
      }
    }
    setOpen(false);
  }

  function getLeagues(filter_) {
    filter_.sport = filter_.sport.id ? filter_.sport.id : 0;
    setLoader(true);
    axiosApi.get(`${config.apiUrl}/leagues${filter_.season_id ? ('/season/' + filter_.season_id) : ''}`, { params: filter_ ? filter_ : filter }).then((resp) => {
      if (resp && resp.data && resp.data.data) {
        const rows = resp.data.data.rows;
        rows.forEach(league => {
          league['teams_count'] = Array.isArray(league.teams) ? league.teams.length : 0;
          league['waiting'] = league.waitingTeams ? league.waitingTeams : 0;
          league['days_played'] = Array.isArray(league.days_played) && league.days_played.some(day => day.indv_reg_allow) ? 'Yes' : 'No';
        })
        setLeagues(rows);
        setTotal(resp.data.data.count);
        setLoader(false);
      }
    }).catch((err) => {
      console.error(err);
      setLoader(false);
    });
  }

  const handleConditionalStyle = (row) => {
    const updateLeagues = leagues.map(league => {
      if (row.id !== league.id) {
        return league;
      }
      return {
        ...league,
        toggleSelected: !league.toggleSelected,
      };
    });
    setLeagues(updateLeagues);
  }

  const handleChangeTable = (e) => {
    if (e.type === 'sort') {
      setFilter(prev => {
        const filter_ = {
          ...prev,
          [e.target.name]: e.target.value,
          direction: e.target.direction,
        };
        getLeagues(filter_);
        return filter_;
      });
    } else {
      setFilter(prev => {
        const filter_ = {
          ...prev,
          [e.target.name]: e.target.value,
        };
        getLeagues(filter_);
        return filter_;
      })
    }
  }

  const moveLeague = (data) => {
    axiosApi.put(`${config.apiUrl}/leagues/bulk/move-league`, {
      season_id: data.id,
      league_ids: selectedLeague,
    }).then(() => {
      setMove(false);
      setSelectedLeague([]);
      getLeagues(filter);
    }).catch((err) => {
      console.error(err);
    })
  }

  const copyLeague = (data) => {
    axiosApi.put(`${config.apiUrl}/leagues/bulk/copy-league`, {
      season_id: data.id,
      league_ids: selectedLeague,
    }).then(() => {
      setCopy(false);
      setSelectedLeague([]);
      getLeagues(filter);
    }).catch((err) => {
      console.error(err);
    })
  }

  const getLeagueStatistics = () => {
    axiosApi.get(`${config.apiUrl}/leagues/statistics${selectedTab ? selectedTab : '/all'}/${filter.season_id ? filter.season_id : 'all'}`)
      .then((resp) => {
        if (resp && resp.data && resp.data.data) {
          const statics = resp.data.data;
          setStatistics([
            {
              text: 'Revenue',
              value: '$0',
              type: 'revenue'
            },
            {
              text: 'Outstanding Revenue',
              value: '$0',
              type: 'revenue'
            },
            {
              text: 'Total Teams',
              value: statics.total_teams || 0,
            },
          ]);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const setPermission = () => {
    if (Array.isArray(permission)) {
      const col = _.cloneDeep(columns_);
      if (permission.includes(PERMISSIONS.LEAGUE_MODIFICATIONS)) {
        setAddEditPermission((prev) => ({ ...prev, league: true }));
      }
      setColumns(loadColumns({ columns: [...col] }));
      if (permission.includes(PERMISSIONS.REVENUE)) {
        setAddEditPermission((prev) => ({ ...prev, revenue: true }));
      } else {
        const idx = col.findIndex(column => column.selector === 'revenue');
        if (idx >= 0) {
          col.splice(idx, 1);
        }
        setColumns(loadColumns({ columns: [...col] }));
      }
    }
  }

  const getSports = () => {
    axiosApi.get(`${config.apiUrl}/misc/sports`)
      .then((resp) => {
        if (resp && resp.data && resp.data.data) {
          if (resp.data.data && resp.data.data.length) {
            setSportsList([{ id: 0, title: 'All' }, ...resp.data.data]);
          }
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }

  const search = () => {
    getLeagues(_.cloneDeep({ ...filter, 'searchString': filter.searchString.trim(), page: 1 }));
  }

  const reset = () => {
    const obj = {
      limit: 50,
      page: 1,
      sort_column: 'created_at',
      direction: 'desc',
      place: '',
      season_id: 0,
      season_name: '',
      status: '',
      indvRegAllow: '',
      searchString: '',
      sport: 0,
    };
    setFilter(obj);
    dispatch(setFilters(obj));
  }

  const deleteLeague = () => {
    const filter_ = _.cloneDeep(filter);
    axiosApi.delete(`${config.apiUrl}/leagues/${leagueId}`)
    .then((res) => {
      getLeagues(filter_);
      setOpenWarningPopup(false);
    })
    .catch(() => {
      setOpenWarningPopup(false);
    })
  }

  return <>
    <div className="content-wrapper leagues-wrapper overview-wrapper">
      <div className="inner-wrapper league-wrapper">
        <div className="heading-wrapper">
          {
            <div className="left">
              <h1 className="heading">{filter.season_id > 0 ? `Current Season: ` : 'All Season'} <span>{filter.season_id > 0 ? filter.season_name : ''}</span></h1>
              <span onClick={() => setOpen(o => !o)}>Change Season</span>
            </div>
          }
          <div className="right">
            {
              filter.season_name &&
              filter.season_id > 0 &&
              Array.isArray(permission) &&
              addEditPermission.league && <Link to={
                {
                  pathname: `/admin/leagues/league/${filter.season_id}`,
                  state: {
                    season_id: filter.season_id,
                    season_name: filter.season_name,
                    type: 'add',
                  }
                }
              } ><button><img src={add} alt='add-league' /><font>Add&nbsp;</font> League</button></Link>}
          </div>
          <Popup open={open} closeOnDocumentClick={BACK_DROP_FALSE} onClose={closeModal}>
            <SeasonPopup closeModal={closeModal} copy={copy} move={move} />
          </Popup>
        </div>
        <Tab tabs={tabs} emit={(e) => {
          setFilter(prev => {
            const place = (e || '').toString().replace('/', '');
            const filter_ = {
              ...prev,
              limit: 50,
              page: 1,
              sort_column: 'created_at',
              direction: 'desc',
              status: '',
              indvRegAllow: '',
              searchString: '',
              sport: 0,
              place,
            }
            if (prev.place !== place) {
              setLeagues([]);
            }
            setSelectedTab(e);
            return filter_;
          });
        }} />
        <div className="cards-wrapper">
          <div className="cards-blk">
            {
              statistics.map((statistic, index) => {
                if (statistic.type === 'revenue') {
                  if (addEditPermission.revenue) {
                    return (
                      <Fragment key={`unique-key-rate-card-${index}`}>
                        <RateCard text={statistic.text} value={statistic.value} />
                      </Fragment>
                    )
                  }
                  return '';
                }
                return (
                  <Fragment key={`unique-key-rate-card-${index}`}>
                    <RateCard text={statistic.text} value={statistic.value} />
                  </Fragment>
                )
              })
            }
          </div>
        </div>
      </div>
      <div className="table-wrapper">
        <div className="search-blk league-search">
          <h2>League Filters</h2>
          <div className="input-blk">
            <div className="search-filter">
              <div className="input-field">
                <label>Search</label>
                <input type="text" id="search_bar" name="search" value={filter.searchString} onChange={(e) => setFilter(prev => ({ ...prev, searchString: e.target.value }))} placeholder="Search by league name..." />
              </div>
              <button type='submit' onClick={search}>Search</button>
            </div>
            <div className="filter-blk">
              <div className="input-wrapper">
                <CustomSelect
                  label={'Status'}
                  data={[
                    {
                      id: '',
                      title: 'All'
                    },
                    {
                      id: 'active',
                      title: 'Active'
                    },
                    {
                      id: 'complete',
                      title: 'Complete'
                    },
                    {
                      id: 'cancel',
                      title: 'Cancel'
                    },
                    {
                      id: 'sign_up',
                      title: 'Sign-up'
                    },
                    {
                      id: 'need_schedule',
                      title: 'Needs Schedule',
                    },
                    {
                      id: 'archive',
                      title: 'Archive'
                    }
                  ]}
                  placeholder={filter.status ? LEAGUE_STATUS[filter.status] : 'All'}
                  type={'status'}
                  onSelect={(ele) => ele && setFilter(prev => ({ ...prev, status: ele.id }))}
                  selector="title"
                />
              </div>
              <div className="input-wrapper">
                <CustomSelect
                  label={'Sport'}
                  data={sportsList}
                  placeholder={![null, undefined, '', 0].includes(filter?.sport?.id) ? filter?.sport?.title : 'All'}
                  type={'status'}
                  onSelect={(ele) => ele && setFilter(prev => ({ ...prev, sport: ele }))}
                  selector="title"
                />
              </div>
              <div className="input-wrapper">
                <CustomSelect
                  label={'IR'}
                  data={[
                    {
                      id: '',
                      title: 'All',
                    },
                    {
                      id: true,
                      title: 'Yes',
                    },
                    {
                      id: false,
                      title: 'No',
                    },
                  ]}
                  placeholder={![null, undefined, ''].includes(filter.indvRegAllow) ? { true: 'Yes', false: 'No' }[filter.indvRegAllow] : 'All'}
                  type={'status'}
                  onSelect={(ele) => ele && setFilter(prev => ({ ...prev, indvRegAllow: ele.id }))}
                  selector="title"
                />
              </div>
              <div className="input-wrapper">
                <button type='submit' onClick={reset}>Reset</button>
              </div>
            </div>
          </div>
        </div>
        <div className="heading-blk">
          <div className="left">
            <h2>Results</h2>
            <p>Select a league to view details.</p>
          </div>
          {
            (filter.season_id > 0) && ((!move && !copy) ?
              <div className="right">
                {
                  leagues && leagues.length > 0 && addEditPermission.league &&
                  <>
                    <button onClick={() => setCopy(true)} className="leagues-btn">Copy Leagues</button>
                    <button onClick={() => setMove(true)} className="leagues-btn">Move Leagues</button>
                  </>
                }
                {
                  <Link to={{
                    pathname: '/admin/leagues/champions',
                    search: `?season_id=${filter.season_id}`
                  }}><button>View Champions</button></Link>}
              </div>
              : <div className="right">
                <button onClick={() => {
                  setMove(false);
                  setCopy(false);
                  setLeagues(leagues.map(league => ({
                    ...league,
                    toggleSelected: false,
                  })));
                }} className="leagues-btn cancel-btn">Cancel</button>
                <button onClick={() => setOpen(o => !o)} className="leagues-btn">Confirm</button>
              </div>)
          }
        </div>
        {/* active */}
        <div className="dataTable active">
          <DataTableComponent key="table-admin-users"
            selectedSeason={{
              season_id: filter.season_id || 0,
              season_name: filter.season_name || 0,
            }}
            loading={loader}
            type={'league_groups'}
            data={leagues}
            columns={columns}
            copy={copy || move}
            handleConditionalStyle={handleConditionalStyle}
            onFilterChange={handleChangeTable}
            conditionalRowStyles={conditionalRowStyles}
            totalPage={total}
            limit={filter.limit} />
        </div>
      </div>
    </div>
    <WarningDialogue
      isOpen={openWarningPopup}
      header={'Warning'}
      description={'Are you sure you want to delete this league?'}
      icon={popupContent.icon}
      action={deleteLeague}
      onClose={() => setOpenWarningPopup(false)}
    />
  </>
}

export default withRouter(Overview);
